// extracted by mini-css-extract-plugin
module.exports = {"arrowWrapper":"navigation_arrowWrapper__jQaPq","arrow":"navigation_arrow__HhU_t"};